import { FC } from "react";
import { useTranslation } from "react-i18next";

import { PNG } from "@ryde/assets";

import { MuiButton } from "../../../controls";
import { RydeProgress } from "../../progress";
import { ProductionNoResultStyled } from "./production-no-result.styled";

interface IProductionNoResultProps {
  onClose: () => void;
}

export const ProductionNoResult: FC<IProductionNoResultProps> = ({
  onClose,
}) => {
  const { t } = useTranslation();
  return (
    <ProductionNoResultStyled>
      <RydeProgress className="ProductionNoResult-Progress" value={0} />
      <img
        src={PNG.ProductionNoResult}
        alt={t("produceButton.PRODUCTION_NO_RESULT_ALT")}
      />
      <section className="ProductionNoResult-Title">
        {t("produceButton.PRODUCTION_NO_BOOKING_FOUND")}&nbsp;
        <span className="ProductionNoResult-TitleAddition">
          {t("produceButton.PRODUCTION_NO_PLEASE_SELECT_BUTTON")}
        </span>
      </section>
      <MuiButton
        className="ProductionNoResult-CloseButton"
        onClick={onClose}
        muiVariant="text"
      >
        {t("general.CLOSE")}
      </MuiButton>
    </ProductionNoResultStyled>
  );
};
